module.exports = __webpack_public_path__ + "static/media/transmission.5922273c.svg";